import {Box} from '@mui/material';

import {isCsmDeployment} from '~utils/deploymentEnv';
import {isProductionEnv} from '~utils/miscUtils';

export function BuildEnvInfo() {
  // isProductionEnv() treats the CSM deployment like production (it runs on production data), but
  // the env badge must still show there: CSMs work in a UI that looks exactly like production, so
  // every tab needs to say which one it is.
  if (isProductionEnv() && !isCsmDeployment) {
    return null;
  }

  const ciEnvName = import.meta.env.VITE_CI_ENVIRONMENT_NAME;
  const authApi = import.meta.env.VITE_AUTH_API;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        fontSize: '10px',
        backgroundColor: 'background.default',
        lineHeight: 1,
        padding: 0.5,
        fontFamily: 'monospace',
      }}
    >
      Env: {isCsmDeployment ? 'CSM (production data)' : ciEnvName || authApi}
    </Box>
  );
}
